<template>
  <div class="w-full max-h-screen bg-background flex flex-col relative">
    <page-header title="Schedule Calendar" backTo="service" />

    <div class="p-6 bg-background flex-1 overflow-y-scroll">
      <div class="w-full bg-white p-5 rounded shadow-md">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center space-x-3">
            <StaffAutocomplete
              v-model="filterEngineer"
              placeholder="Filter by engineer..."
              class="w-64"
            />
            <Dropdown
              v-model="filterStatus"
              :options="statusOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="All Statuses"
              class="w-48"
            />
            <button
              @click="refreshCalendar"
              class="px-4 py-2 bg-blue-200 border border-blue-400 hover:bg-blue-300 hover:border-blue-500 rounded transition-colors"
            >
              Apply
            </button>
          </div>
        </div>

        <FullCalendar
          ref="calendar"
          :options="calendarOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import Dropdown from "primevue/dropdown";
import StaffAutocomplete from "@/components/AutoComplete/StaffAutoComplete.vue";
import notificationMixin from "@/mixins/notificationMixin";

export default {
  name: "ScheduleCalendar",
  mixins: [notificationMixin],
  components: { FullCalendar, Dropdown, StaffAutocomplete },
  data() {
    return {
      filterEngineer: null,
      filterStatus: null,
      statusOptions: [
        { label: "All", value: null },
        { label: "Assigned", value: "Assigned" },
        { label: "In Progress", value: "InProgress" },
        { label: "Completed", value: "Completed" },
      ],
    };
  },
  computed: {
    ...mapState("scheduleCalendar", ["calendarEvents", "isLoading"]),
    calendarOptions() {
      return {
        plugins: [dayGridPlugin],
        initialView: "dayGridMonth",
        events: this.calendarEvents,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,dayGridWeek",
        },
        eventClick: this.onEventClick,
        datesSet: this.onDatesSet,
        height: "auto",
      };
    },
  },
  methods: {
    onDatesSet(info) {
      const fromDate = this.$moment(info.start).format("DD/MM/YYYY");
      const toDate = this.$moment(info.end).format("DD/MM/YYYY");
      this.loadCalendar(fromDate, toDate);
    },
    loadCalendar(fromDate, toDate) {
      const params = { fromDate, toDate };
      if (this.filterEngineer && this.filterEngineer.staff_id) {
        params.engineer_id = this.filterEngineer.staff_id;
      }
      if (this.filterStatus) {
        params.status = this.filterStatus;
      }
      this.$store.dispatch("scheduleCalendar/fetchCalendar", params);
    },
    refreshCalendar() {
      const calendarApi = this.$refs.calendar.getApi();
      const view = calendarApi.view;
      const fromDate = this.$moment(view.activeStart).format("DD/MM/YYYY");
      const toDate = this.$moment(view.activeEnd).format("DD/MM/YYYY");
      this.loadCalendar(fromDate, toDate);
    },
    onEventClick(info) {
      const props = info.event.extendedProps;
      if (props.schedule_id) {
        this.$router.push({
          name: "schedule-detail",
          params: { scheduleId: props.schedule_id },
        });
      }
    },
  },
};
</script>
